const offerCommandItems = (app, store, t) => {
  const { cmdBar: cmd } = store;
  const { features } = app;

  const items = [];

  if (!features.registrationReadOnly) {
    items.push({
      key: 'upload',
      name: t('Upload'),
      iconProps: {
        iconName: 'CloudUpload',
      },
      iconOnly: true,
      disabled: !cmd.offerUploadEnabled,
      onClick: () => store.ui.registerOnBehalf(),
    });
  }

  items.push({
    key: 'refuse',
    name: t('Refuse'),
    iconProps: {
      iconName: 'ReceiptUndelivered',
    },
    iconOnly: true,
    disabled: !cmd.offerRefuseEnabled,
    onClick: () => store.ui.refuseOffer(),
  });
  //{
  //   key: 'award',
  //   name: t('Award'),
  //   icon: 'DecisionSolid',
  //   iconOnly: true,
  //   disabled: !cmd.offerAwardEnabled,
  //   onClick: () =>
  //     store.ui.prompt.open({ title: t('Kaufangebot annehmen'), message: t('Sind Sie sicher? Alle anderen Kunden bekommen entsprechende ablehnungs Benachrichtigung.'), action: () =>
  //       store.offers.award()
  //     })
  // }, {
  //   key: 'accept',
  //   name: t('Accept'),
  //   icon: 'Accept',
  //   iconOnly: true,
  //   disabled: !cmd.offerAcceptEnabled,
  //   onClick: () => store.offers.accept()
  // }, {
  //   key: 'reject',
  //   name: t('Reject'),
  //   icon: 'Blocked',
  //   iconOnly: true,
  //   disabled: !cmd.offerRejectEnabled,
  //   onClick: () =>
  //     store.ui.prompt.open({ title: t('Angebot endgültig ablehnen'), message: t('Sind Sie sicher?'), action: () =>
  //       store.offers.reject()
  //     })
  // },
  items.push({
    key: 'offer',
    name: t('Offer'),
    subMenuProps: {
      items: [
        {
          key: 'confirm-on-behalf',
          name: t('Confirm'),
          iconProps: {
            iconName: 'SkypeCircleCheck',
          },
          iconOnly: true,
          onClick: () => store.offers.confirmOnBehalf(),
          disabled: !cmd.offerConfirmOnBehalfEnabled,
        },
        {
          key: 'pdf',
          name: t('PDF Export'),
          iconProps: {
            iconName: 'PDF',
          },
          iconOnly: true,
          onClick: () => store.ui.printOffer(),
          disabled: !cmd.offerPreviewEnabled,
        },
        {
          key: 'update-contact',
          name: t('Update Contact'),
          iconProps: {
            iconName: 'EditContact',
          },
          iconOnly: true,
          onClick: () => store.ui.updateContact(),
          disabled: !cmd.updateContactEnabled,
        },

        // {
        //   key: 'accept',
        //   name: t('Accept'),
        //   iconProps: {
        //     iconName: 'Accept',
        //   },
        //   iconOnly: true,
        //   disabled: !cmd.offerAcceptEnabled,
        //   onClick: () => store.offers.accept(),
        // },
      ],
    },
  });

  return items;
};

export { offerCommandItems };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Commands/offerCommandItems.js